import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HealthRecordRoutingModule } from './health-record.routing.module';
import { HealthRecordComponent } from './health-record.component';
import { RecordReleaseModalComponent } from './record-release-modal/record-release-modal.component';
import { SharedModule } from '../shared/shared.module';
import { MaterialModule } from '../shared/material/material.module';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OtherDocumentsComponent } from './other-documents/other-documents.component';
import { UploadDocumentModalComponent } from './other-documents/modals/upload-document-modal/upload-document-modal.component';
import { DeleteDocumentModalComponent } from './other-documents/modals/delete-document-modal/delete-document-modal.component';
import { UploadViewerComponent } from './other-documents/containers/upload-viewer/upload-viewer.component';
import { DocumentActionsComponent } from './other-documents/containers/document-actions/document-actions.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SsnVerificationModalComponent } from './ssn-verification-modal/ssn-verification-modal.component';
import { AdditionalDocumentsResolver } from './../../services/resolvers/additional-documents-resolver.service';
import { NativeElementInjectorDirective } from '../shared/directives/native-element-injector.directive';

@NgModule({
	imports: [
		CommonModule,
		HealthRecordRoutingModule,
		SharedModule,
		MaterialModule,
		PdfViewerModule,
		ReactiveFormsModule,
	],
	declarations: [
		HealthRecordComponent,
		OtherDocumentsComponent,
		UploadDocumentModalComponent,
		DeleteDocumentModalComponent,
		UploadViewerComponent,
		DocumentActionsComponent,
		RecordReleaseModalComponent,
		SsnVerificationModalComponent,
		NativeElementInjectorDirective,
	],
	exports: [
		HealthRecordComponent,
		OtherDocumentsComponent,
		UploadDocumentModalComponent,
		DeleteDocumentModalComponent,
		UploadViewerComponent,
		DocumentActionsComponent,
		RecordReleaseModalComponent,
		SsnVerificationModalComponent,
	],
	providers: [
		{ provide: MAT_DIALOG_DATA, useValue: {} },
		{ provide: MatDialogRef, useValue: {} },
		AdditionalDocumentsResolver,
	],
})
export class HealthRecordModule {}
